import React, { useMemo } from "react";
import "./styles.scss";
import { type Prize } from "kadow-jetpack-model";
import { useAccountToDisplaySelector } from "../../../../redux/actions/user";
import {
  DEFAULT_PC_GIFT,
  type ISector,
  SECTOR_LIST
} from "../../../../utils/constants";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import TwemojiWrapper from "../../../TwemojiWrapper/TwemojiWrapper";

export default function SuggestionRadioSelector({
  onSelect,
  value
}: SuggestionRadioSelectorProps) {
  const { accountToDisplay } = useAccountToDisplaySelector();
  const selectedSector: ISector = useMemo(() => {
    return (
      SECTOR_LIST.filter(
        (sector) =>
          sector.value === accountToDisplay?.businessUser?.customerType
      )[0] || SECTOR_LIST[0]
    );
  }, [accountToDisplay]);

  const handleOptionChange = (optionName: string, idx: number) => {
    const newPrize: Partial<Prize> = {
      name: optionName,
      image: selectedSector.icon[idx],
      isVoucher: false,
      pc: DEFAULT_PC_GIFT,
      description: "",
      conditions: [""]
    };
    onSelect(newPrize);
  };

  return (
    <div className="radio-group w-100 d-flex flex-column st-gap">
      {selectedSector.prizes.map((option, idx) => {
        const isSelected = value?.name === option;

        return (
          <div
            key={option}
            className={`radio-option ${isSelected ? "radio-selected" : ""}`}
          >
            <label className="d-flex align-items-center w-100 mb-0 p-3 gap-sm">
              <input
                type="radio"
                name="radio-option"
                value={option}
                checked={isSelected}
                onChange={() => {
                  handleOptionChange(option, idx);
                }}
                className="radio-input"
              />
              <TwemojiWrapper isText={true}>
                <KC_UIText
                  text={`${option} ${selectedSector.icon[idx]} `}
                  weight={"reg"}
                />
              </TwemojiWrapper>
            </label>
          </div>
        );
      })}
    </div>
  );
}

interface SuggestionRadioSelectorProps {
  onSelect: (value: Partial<Prize>) => void;
  value: Partial<Prize> | null;
}
